/**
 * Different light polarisation modes of the dermatoscope.
 */
export enum DermatoscopePolarisation {
  Polarised = 'polarised',
  NonPolarised = 'non-polarised',
}
